exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2ba82c1b!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UndertakerOverview.vue
// module id = 363
// module chunks = 0